import React from 'react';
import PropTypes from 'prop-types';
import { SubParagraph } from '../../../legacy/hui/src/styled/';

const ModalSubParagraph = SubParagraph.extend`
  font-size: 20px;
  padding-top: 10px;
  text-align: left;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 15px;
    padding-top: 5px;
  }
`;

const Content = props => {
  const { first, second } = props;
  return (
    <div>
      <ModalSubParagraph>
        {`We’re in the process of upgrading our systems to improve the experience 
      ${first}`}
      </ModalSubParagraph>
      <ModalSubParagraph>
        {second}
        or call 1300 043 520 to book your install.
      </ModalSubParagraph>
    </div>
  );
};

Content.propTypes = {
  first: PropTypes.string.isRequired,
  second: PropTypes.string.isRequired
};

export const DifferentCode = () => (
  <Content
    first={'so the install code you received in-store may not be 20 digits.'}
    second={
      'If you have an Installation Voucher Receipt with a 14 digit code or an Install Card with a scratch panel '
    }
  />
);

export const NoVoucher = () => (
  <Content
    first={'so you may not have received an installation voucher with your purchase in store.'}
    second={
      'If you did NOT receive an Installation Voucher Receipt with an install code and a date please tap the button below '
    }
  />
);
